import type { CccConfig, ProcessableRtes } from '../C3ServerlessBundle';

export const PROD_RTES = ['PROD', 'PRD', 'PRODUCTION'];
const NON_PROD_RTES = ['TEST', 'ENG', 'SAT', 'PRF', 'CAT', 'DEV', 'LOCAL'];
const APP_PREFIX_LENGTH = 3;

function standardizeRte(inputValue: string): ProcessableRtes.ProdProcessableRte | ProcessableRtes.NonprodProcessableRte | '' {
  const isProd = PROD_RTES.includes(inputValue.toUpperCase());
  const isNonProd = NON_PROD_RTES.includes(inputValue.toUpperCase());
  const isValidRte = isNonProd || isProd;
  if (!isValidRte) {
    return '';
  }
  return isProd ? ('PROD' as ProcessableRtes.ProdProcessableRte) : ('NONPROD' as ProcessableRtes.NonprodProcessableRte);
}

export const isObject = (object: any) => typeof object === 'object' && object !== null && !Array.isArray(object);
export const isArray = (array: any) => Array.isArray(array);
export const isBoolean = (bool: any) => typeof bool === 'boolean';
export const isString = (str: any) => typeof str === 'string';

export const validateC3Config = (data: CccConfig) => {
  try {
    if (!isObject(data)) {
      throw new Error('Wrong config type');
    }

    if (!isString(data.site)) {
      throw new Error('"site" property of wrong type. Expected type "string"');
    }

    if (!isString(data.app)) {
      throw new Error('"app" property of wrong type. Expected type "string"');
    }
    if (data.app.length !== APP_PREFIX_LENGTH) {
      throw new Error('App prefix must be 3 characters');
    }

    if (!data.appConfig) {
      data.appConfig = {};
    } else if (!isObject(data.appConfig)) {
      throw new Error('"appConfig" property of wrong type. Expected type "object"');
    }

    const rteTest = standardizeRte(data.rte);
    if (rteTest === '') {
      throw new Error('Invalid "rte" property');
    }
    data.rte = rteTest as ProcessableRtes.ProdProcessableRte | ProcessableRtes.NonprodProcessableRte;

    if (!isString(data.concerns)) {
      throw new Error('"concerns" property of wrong type. Expected type "string"');
    }
    if (!data.concerns) {
      throw new Error('"concerns" is a required field');
    }

    return data;
  } catch (error) {
    console.error(`Invalid Config provided failing on: ${error}`);
    return undefined;
  }
};
